import { useSnackbar } from 'notistack';
import React from 'react';
import { useCustomerData } from '../customerData';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  Select,
  Typography
} from '@mui/material';
import { useStyles } from 'src/theme/vemigoCustomStyles/VemigoCustomStyles';
import VemigoTextFeild from 'src/components/VemigoGrid/VemigoTextFeild';
import { CustomerAddresseServicess } from 'src/services/customer/addresseServices';
import { StatusSwitch } from 'src/components/VemigoGrid/VemigoStarusFeild';
import { useCustomerBookingCart } from '../selectedCustomerData';

export const EditCustomersAddress = (props) => {
  const { handleGetCustomerAddressById, selectedCustomerData } =
    useCustomerBookingCart();

  const { rowData, data, open, handleClose } = props;

  const dataModel = {
    addressId: 0,
    name: '',
    addressLine1: '',
    addressLine2: '',
    contactNumber1: '',
    contactNumber2: '',
    mobileNumber: '',
    landMark: '',
    geoLocation: '',
    cityID: 0,
    areaID: 0,
    isActive: true,
    customerAddressTypeId: 0
  };

  const [newData, setNewData] = React.useState(dataModel);
  const { enqueueSnackbar } = useSnackbar();
  const { customerAddressTypes, allCities, allAreas } = useCustomerData();
  const [selectedAddressTypeList, setSelectedAddressTypeList] = React.useState(
    []
  );
  const [selectedAddressTypeId, setSelectedAddressTypeId] = React.useState('');
  const [selectedCityList, setSelectedCityList] = React.useState([]);
  const [selectedCityId, setSelectedCityId] = React.useState('');
  const [selectedAreaList, setSelectedAreaList] = React.useState([]);
  const [selectedAreaId, setSelectedAreaId] = React.useState('');
  const [isEditDialogOpen, setEditDialogOpen] = React.useState(false);
  const [isAddButtonDisabled, setIsAddButtonDisabled] = React.useState(true);

  const address = data.find(
    (item) => item.addressId === rowData || item.addressId === rowData.addressId
  );

  const handleAddClose = () => {
    handleClose();
    setNewData(dataModel);
    setSelectedAreaList(allAreas);
    setSelectedAreaId('');
    setSelectedCityId('');
    setIsAddButtonDisabled(true);
    setSelectedAddressTypeId('');
  };

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        setNewData({
          addressId: address.addressId,
          name: `${selectedCustomerData.firstAndMiddleName}${' '}${selectedCustomerData.lastName}`,
          addressLine1: address.addressLine1,
          addressLine2: address.addressLine2,
          contactNumber1: address.contactNumber1,
          contactNumber2: address.contactNumber2,
          mobileNumber: address.mobileNumber,
          landMark: address.landMark,
          geoLocation: address.geoLocation,
          cityID: address.cityID,
          areaID: address.areaID,
          isActive: address.isActive,
          customerAddressTypeId: address.customerAddressTypeId
        });
        setSelectedAreaList(
          allAreas.filter((x) => x.city.id === address.cityID)
        );
        setSelectedAddressTypeId(address.customerAddressTypeId);
        setSelectedCityId(address.cityID);
        setSelectedAreaId(address.areaID);
        setSelectedAddressTypeList(customerAddressTypes);
        setSelectedCityList(allCities);
        setSelectedAreaList(allAreas);
      } catch (error) {
        console.error('Error fetching data from the API:', error);
      }
    };
    fetchData();
  }, []);

  const handleDataChange = (fieldName, value) => {
    setNewData({ ...newData, [fieldName]: value });

    if (fieldName === 'cityID') {
      setSelectedAreaList(allAreas.filter((x) => x.city.id === value));
      setSelectedAreaId('');
    }
  };

  const handleAddNewData = () => {
    if (
      !newData.addressLine1 ||
      !newData.addressLine2 ||
      !newData.areaID ||
      !newData.cityID ||
      !newData.mobileNumber
    ) {
      enqueueSnackbar('Please fill in all mandatory fields', {
        variant: 'error'
      });
      return;
    }

    CustomerAddresseServicess.editData(newData)
      .then((data) => {
        handleGetCustomerAddressById('Get');
        props.handleEditeData(true);
      })
      .catch((error) => {
        console.error('Error updating data:', error);
      });

    handleAddClose();
  };

  const getFieldValue = (fieldId) => {
    if (fieldId.includes('.')) {
      const [parent, child] = fieldId.split('.');
      return newData[parent][child] || '';
    }
    return newData[fieldId] || '';
  };

  const india = '+91';

  const allFields = [
    {
      id: 'customerAddressTypeId',
      field: 'Select',
      title: 'Address Type*',
      type: 'Home',
      selectedId: selectedAddressTypeId,
      dataList: selectedAddressTypeList,
      function: setSelectedAddressTypeId,
      size: 6
    },
    {
      id: 'name',
      field: 'textField',
      title: 'Name*',
      type: 'text',
      size: 6
    },
    {
      id: 'addressLine1',
      field: 'textField',
      title: 'Address Line 1*',
      type: 'text',
      size: 12
    },
    {
      id: 'addressLine2',
      field: 'textField',
      title: 'Address Line 2*',
      type: 'text',
      size: 12
    },
    {
      id: 'cityID',
      field: 'Select',
      title: 'Select City*',
      type: 'City...',
      selectedId: selectedCityId,
      dataList: selectedCityList,
      function: setSelectedCityId,
      size: 6
    },
    {
      id: 'areaID',
      field: 'Select',
      title: 'Select Area*',
      type: 'Area...',
      selectedId: selectedAreaId,
      dataList: selectedAreaList,
      function: setSelectedAreaId,
      size: 6
    },
    {
      id: 'geoLocation',
      field: 'textField',
      title: 'Geo Location*',
      type: 'text',
      size: 6
    },
    {
      id: 'landMark',
      field: 'textField',
      title: 'Land Mark',
      type: 'text',
      size: 6
    },
    {
      id: 'mobileNumber',
      field: 'textField',
      title: 'Contact Number',
      type: 'text',
      size: 6,
      useFor: india,
      maxChars: 11 + india.length
    },
    {
      id: 'isActive',
      field: 'status',
      size: 12
    }
  ];

  const handleEditDialogClose = () => {
    setEditDialogOpen(false);
  };

  return (
    <>
      <Dialog open={open} onClose={handleEditDialogClose}>
        <DialogTitle style={useStyles.dialogTitle}>Edit Address</DialogTitle>
        <DialogContent style={useStyles.bodyStyle}>
          <Grid container spacing={2} style={useStyles.boxSize}>
            {allFields.map((field) => (
              <Grid item xs={field.size} key={field.id}>
                <Typography style={useStyles.formTitle}>
                  {field.title}
                </Typography>
                {field.field === 'textField' && (
                  <VemigoTextFeild
                    style={useStyles.formControl}
                    id={field.id}
                    type={field.type}
                    fullWidth
                    autoFocus={false}
                    useFor={field.useFor}
                    counter={false}
                    maxChars={field.maxChars}
                    value={getFieldValue(field.id) || ''}
                    onChange={(e) => handleDataChange(field.id, e.target.value)}
                    key={`textfield-${field.id}`}
                  />
                )}
                {field.field === 'Select' && (
                  <Select
                    displayEmpty
                    style={useStyles.formControl}
                    fullWidth
                    value={field.selectedId}
                    onChange={(e) => {
                      handleDataChange(field.id, e.target.value);
                      field.function(e.target.value);
                    }}
                  >
                    <MenuItem value="" disabled key={`${field.id}-empty`}>
                      <em>{field.type}</em>
                    </MenuItem>
                    {field.dataList.map((data) => (
                      <MenuItem key={data.id} value={data.id}>
                        {data.name}
                      </MenuItem>
                    ))}
                  </Select>
                )}
                {field.field === 'status' && (
                  <StatusSwitch
                    newData={newData}
                    handleSwitchChange={handleDataChange}
                    field={field.id}
                  />
                )}
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAddClose} variant="contained">
            Cancel
          </Button>
          <Button
            onClick={handleAddNewData}
            color="primary"
            variant="contained"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
